import * as React from "react";
const SvgBigRedSandWatch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      stroke="#F05353"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M4.565 21.542C6.135 27.5 11.552 31.89 17.997 31.89A13.86 13.86 0 0 0 31.887 18c0-9.265-7.723-13.89-7.723-13.89m0 0h4.598m-4.598 0v4.431"
    />
    <path
      stroke="#F05353"
      strokeDasharray="4.17 4.17"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M17.998 4.11c-7.667 0-13.89 6.223-13.89 13.89"
    />
    <path
      stroke="#F05353"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M20.34 11.489h-4.22c-2.448 0-2.636 2.2-1.315 3.399l6.85 6.224c1.322 1.198 1.133 3.399-1.315 3.399h-4.22c-2.448 0-2.636-2.2-1.315-3.399l6.85-6.224c1.322-1.198 1.133-3.399-1.315-3.399"
    />
  </svg>
);
export default SvgBigRedSandWatch;
